import FieldLabel from './FieldLabel'
import './styles.scss'

type Props = {
  label?: string | React.ReactElement
  size?: 'sm' | 'md' | 'lg'
  tooltip?: string
  singleLine?: boolean
  align?: 'start' | 'end'
  optional?: boolean
  [x: string]: any
}

const Input: React.FC<Props> = ({ label, size='md', tooltip, className, required, optional, ...rest }) => {
  return (
    <>
      {label && (
        <FieldLabel label={label} htmlFor={rest.id} size={size} tooltip={tooltip} required={required} optional={optional} />
      )}
      <input className={`form-control form-control-${size} ${className ?? ''}`.trim()} required={required} {...rest} />
    </>
  )
}


export const CalculatedInput: React.FC<Props> = ({ label, size='md', tooltip, className, align='start', singleLine, ...rest }) => {
  const wrapperClassName = singleLine ? 'calculated-input-single-line' : ''
  const labelClassName = `${singleLine ? 'calculated-input-label-inline' : ''} ${align === 'end' ? 'w-100 text-end' : ''}`.trim()
  return (
    <div className={wrapperClassName || undefined}>
      {label && (
        <FieldLabel label={label} htmlFor={rest.id} size={size} tooltip={tooltip} className={labelClassName} />
      )}
      <input className={`form-control form-control-${size} border-0 bg-transparent px-0 shadow-none ${align === 'end' ? 'text-end' : ''} ${className || ''}`.trim()} readOnly {...rest} />
    </div>
  )
}

export default Input
